export const API_HOST = process.env.REACT_APP_API_HOST;

export const PASSWORD_PATTERN = /^(?=.*[\d])(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&*_-])[\w!@#$%^&*_-]{8,}$/

export const DEFAULT_PAGINATION_PAGE = 0
export const DEFAULT_PAGINATION_PER_PAGE = 10

export const DATE_TIME_FORMAT = 'dd/MM/yyyy HH:mm'